import type { ValuesSchemaType } from "./schemas";
import type { PageFilterState } from "@/components/providers/AppFilterProvider/types";

export function partitionFilterValues(
  availableValues: ValuesSchemaType,
  activeValueIds: string[],
) {
  const activeValues = availableValues.filter((v) =>
    activeValueIds.includes(String(v.value)),
  );
  const inactiveValues = availableValues.filter(
    (v) => !activeValueIds.includes(String(v.value)),
  );
  return { activeValues, inactiveValues };
}

export function partitionByActive(values: ValuesSchemaType) {
  const activeValues = values.filter((v) => v.active);
  const inactiveValues = values.filter((v) => !v.active);
  return { activeValues, inactiveValues };
}

export function getActiveFilterCount(pageFilters: PageFilterState): number {
  return Object.values(pageFilters).reduce(
    (sum, f) => sum + (f.values?.length ?? 0),
    0,
  );
}
